<div class="row card-row">
    <div class="navbar navbar-light bg-light navbar-expand-md">
      <span class="navbar-brand">
        <span *ngIf="bills_start_date">{{ bills_start_date | amDateFormat:'MMMM YYYY' }}</span>
        <span *ngIf="bills_end_date && bills_start_date != bills_end_date"> - {{ bills_end_date | amDateFormat:'MMMM YYYY' }}</span>
      </span>

      <div class="collapse navbar-collapse">
        <ul class="navbar-nav me-auto"></ul>

        <form [formGroup]="bills_form" (ngSubmit)="billsSubmit()">
            <kendo-dropdownlist placeholder="Start Month" formControlName="start_month" [data]="months" textField="text"
                valueField="value" [valuePrimitive]="true" class="filter-control me-1">
            </kendo-dropdownlist>
            <kendo-numerictextbox placeholder="Start Year" formControlName="start_year" [min]="2000" [max]="2050"
                [autoCorrect]="true" [format]="'0'" class="filter-control me-1">
            </kendo-numerictextbox>
            <span><fa-icon [icon]="faLongArrowAltRight" [fixedWidth]="true"></fa-icon></span>
            <kendo-dropdownlist placeholder="End Month" formControlName="end_month" [data]="months" textField="text"
                valueField="value" [valuePrimitive]="true" class="filter-control me-1">
            </kendo-dropdownlist>
            <kendo-numerictextbox placeholder="End Year" formControlName="end_year" [min]="2000" [max]="2050"
                [autoCorrect]="true" [format]="'0'" class="filter-control me-1">
            </kendo-numerictextbox>
            <button kendoButton [primary]="true" [svgIcon]="searchIcon" type="submit" [disabled]="!bills_form.valid">
                Search
            </button>
        </form>
      </div>
    </div>

    <nexus-grid [data]="provider_bill_charges_model">
        <kendo-grid-column field="date_created" title="Created" format="G" filter="date" [width]="170"></kendo-grid-column>        
        <kendo-grid-column field="expected_bill.provider.name" title="Provider" [width]="150"></kendo-grid-column>
        <kendo-grid-column field="provider_category.name" title="Category" [width]="150"></kendo-grid-column>
        <kendo-grid-column field="expected_bill.description" title="Address" [width]="170"></kendo-grid-column>
        <kendo-grid-column field="expected_bill.group.address2" title="Unit" [width]="100"></kendo-grid-column>
        <kendo-grid-column field="expected_bill.account_number" title="Account" [width]="170"></kendo-grid-column>        
        <kendo-grid-column field="expected_bill.meter_number" title="Meter" [width]="120"></kendo-grid-column>
        <kendo-grid-column field="provider_bill.amount" title="Bill Amount" filter="numeric" format="{0:c}" [width]="150"></kendo-grid-column>
        <kendo-grid-column field="provider_bill.billing_period_date" title="Billing Period" format="y" filter="date" [width]="150"></kendo-grid-column>
        <kendo-grid-column field="provider_bill.date_due" title="Due" format="d" filter="date" [width]="100"></kendo-grid-column>
        <kendo-grid-column field="amount" title="Amount" filter="numeric" format="{0:c}" [width]="120"></kendo-grid-column>        
        <kendo-grid-column field="floorplan_average_amount" title="Floor Plan Average" format="{0:c}" [filter]="'numeric'" [width]="170"></kendo-grid-column>        
        <kendo-grid-column field="resident_portion" title="Resident Portion" filter="numeric" format="{0:c}" [width]="170"></kendo-grid-column>        
        <kendo-grid-column field="allowance_portion" title="Allowance" filter="numeric" format="{0:c}" [width]="150"></kendo-grid-column>        
        <kendo-grid-column field="property_portion" title="Property Portion" filter="numeric" format="{0:c}" [width]="170"></kendo-grid-column>  
        <kendo-grid-column field="start_date" title="Start Date" format="d" filter="date" [width]="150"></kendo-grid-column>
        <kendo-grid-column field="end_date" title="End Date" format="d" filter="date" [width]="150"></kendo-grid-column>
        <kendo-grid-column field="ledger_code.name" title="Ledger Code" [width]="170"></kendo-grid-column>
        <kendo-grid-column field="provider_bill.paid" title="Provider Paid" [width]="150"></kendo-grid-column>
        <kendo-grid-column field="date_released" title="Released" format="G" filter="date" [width]="170" [hidden]="true"></kendo-grid-column>
        <kendo-grid-column field="provider_bill.source_type" title="Source Type" [width]="150" [hidden]="true"></kendo-grid-column>
        <kendo-grid-column field="consumption_display" title="Consumption" [width]="130" [hidden]="true">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span *ngIf="dataItem.consumption != null">{{ dataItem.consumption | number:'1.0-2' }} {{ dataItem.usage_unit?.name }}</span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [width]="80" title="Pdf">
        <ng-template kendoGridCellTemplate let-dataItem>
        <button kendoButton *ngIf="(dataItem.provider_bill_file_id || dataItem.provider_bill_charge_file_id) && dataItem.provider_bill.source_type != 'MeterConversion'" [svgIcon]="filePdfIcon"
              (click)="exportBill(dataItem)"></button>
        <button kendoButton *ngIf="dataItem.provider_bill.source_type == 'MeterConversion'" [svgIcon]="filePdfIcon"
              (click)="exportBill(dataItem)"></button>
        </ng-template>
  </kendo-grid-column>
    </nexus-grid>
</div>